
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigation = [
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Team', href: '#team' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 py-6">
      <nav className="mx-auto px-6 lg:px-12">
        <div className="bg-stone-50/90 backdrop-blur-md rounded-full px-8 py-4 border border-stone-200/50 shadow-lg">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-medium text-stone-800">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full border-2 border-stone-800 flex items-center justify-center overflow-hidden">
                    <img 
                      src="https://static.readdy.ai/image/000745ea5477ac1971ad11ea6f2dc4d7/33a711b38a4a896caf5d5cfa5c0fffeb.jpeg" 
                      alt="Legal Findings and Studies Logo" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="font-light">Legal Findings and Studies, Lda.</span>
                </div>
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              {navigation.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href.replace('#', ''))}
                  className="text-stone-700 hover:text-stone-900 font-light transition-colors cursor-pointer"
                >
                  {item.name}
                </button>
              ))}
              <button 
                onClick={scrollToContact}
                className="bg-stone-800 text-stone-50 px-6 py-2 text-sm font-light hover:bg-stone-900 transition-colors whitespace-nowrap cursor-pointer rounded-full"
              >
                Contact
              </button>
            </div>

            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-stone-800 hover:text-stone-600 cursor-pointer"
              >
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="md:hidden border-t border-stone-200 mt-4 pt-4">
              <div className="space-y-4">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      scrollToSection(item.href.replace('#', ''));
                      setIsMenuOpen(false);
                    }}
                    className="block text-stone-700 hover:text-stone-900 font-light cursor-pointer w-full text-left"
                  >
                    {item.name}
                  </button>
                ))}
                <button 
                  onClick={scrollToContact}
                  className="w-full bg-stone-800 text-stone-50 px-6 py-2 text-sm font-light hover:bg-stone-900 transition-colors cursor-pointer rounded-full"
                >
                  Contact
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
}
